import { useParams } from "react-router-dom";
import { useQueryClient } from "react-query";
import moment from "moment";

/** Chapter of the section not released yet for the session of the learner */
const locked = section => {
    const unlockAt = section.chapter?.unlockAt;
    return unlockAt && moment(unlockAt).valueOf() > moment().valueOf();
}

export default function useFirstSection(){

    const {course} = useParams();

    const queryClient = useQueryClient();

    return () => {
        const data = queryClient.getQueryData(course);
        const sections = data.chapters.reduce((a,b) => a.concat(b.sections), []);

        /**
         * Landing on a locked section shows a padlock instead of the course,
         * so the first one still to come is preferred. A learner whose session
         * has not opened yet has none, and lands on the padlock after all.
         */
        const available = sections.filter(s => !locked(s));

        return available.find(s => !s.completed) || available[0] || sections[0];
    }
}
